import { PriceSettingEnum } from "@infrastructure/price-setting.enum";

export class PriceSettingModel {

	PriceSetting?: PriceSettingEnum;
	PriceSettingDescription?: string;

	constructor(priceSetting?: PriceSettingEnum, priceSettingDescription?: string) {
		this.PriceSetting = priceSetting;
		this.PriceSettingDescription = priceSettingDescription
	}

}
